import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import MedicalHistoryForm from './MedicalHistoryForm';
import authActions from '../../../auth/authActions';
import userActions from '../../../user/userActions';
import quotingActions from '../../quotingActions';
import settingsActions from '../../../common/settingsActions';

interface Props {
	user: UserDetails;
	customerDetails: CustomerDemographicDetails;
	questions: any;
	questionnaire: any;
	actions: any;
	history: any;
	match: any;
	className?: string;
	onQuestionnaireBlur: (e: any) => Promise<any>;
	onQuestionnaireChange: (e: any) => void;

	hwTable: HeightWeight[];
}
class MedicalHistoryPage extends React.Component<Props, any> {
	isNextDisabled = () => {
		if (this.props.questionnaire.prescriptionPainkillers == null
			|| this.props.questionnaire.furtherExamination == null
			|| this.props.questionnaire.notConsultedDoctor == null
			|| !this.props.questionnaire.familyDiagnosis
			|| !this.props.questionnaire.familyKidneyDisease
			|| !this.props.questionnaire.cancer.isValid) {
			return true;
		}

		return false;
	}

	save = () => {
		return this.props.actions.saveUser(this.props.user)
		.then(() => {
			const customerDetails: CustomerDemographicDetails = {
				...this.props.customerDetails,
				customerId: this.props.user.id
			};
			return this.props.actions.saveCustomerDetails(customerDetails);
		});
	}

	back = () => {
		this.save()
		.then(() => this.props.history.push(`/quote/${this.props.match.params.workflow}/enrollment/activities#3`));
	}
	next = () => {
		window['dataLayer'].push({ event: 'questionnaireComplete' }); // tslint:disable-line
		
		this.props.actions.setQuestionnaireNavigationEnabled(false);
		this.save()
		.then(() => {
			this.props.actions.setQuestionnaireNavigationEnabled(true);
			this.props.history.push(`/quote/${this.props.match.params.workflow}/enrollment/review`);
		});
	}

	render() {
		const { className, ...props } = this.props;
		return (
			<MedicalHistoryForm {...props} parentNext={this.next} parentPrev={this.back} />
		);
	}
}

function mapStateToProps(state: any) {
	return {
		questions: state.question.questions,
		questionnaire: state.policy.questionnaire,
		user: state.user.user
	};
}
function mapDispatchToProps(dispatch: any) {
	const actions = { ...authActions, ...quotingActions, ...userActions, ...settingsActions };
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(MedicalHistoryPage);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/quoting/enrollment/create-your-account/MedicalHistoryPage.tsx